import styled from 'styled-components';
import { desktop_breakpoint } from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const BuilderResourcesStyles = styled.div`
  .full-width-bg {
    background-color: ${Colors.accent.grey7.standard};
  }
  .area-header {
    padding: 35px 0 45px 0;
    margin-bottom: 45px;

    .hero-heading {
      font-size: 40px;
    }
  }
  h2 {
    margin-bottom: 20px;
  }
  .intro-p {
    margin-bottom: 15px;
  }
  .pdf-blurbs {
    margin-top: 40px;

    .pdf-blurb-icon {
      min-width: 36px;
    }
    .pdf-blurb {
      margin-bottom: 30px;
    }
    .pdf-link:link,
    .pdf-link:visited,
    .pdf-link:hover,
    .pdf-link:active {
      text-decoration: none;
    }
  }
  .xsmall {
    margin-bottom: 20px;
  }
  .foundation-sys {
    padding: 80px 0 50px 0;
  }
  .tech-notes {
    padding: 80px 0 37px 0;
  }
  .foundation-systems-blurb {
    margin-bottom: 40px;
  }
  @media only screen and (min-width: ${desktop_breakpoint}px) {
    .area-header {
      padding: 80px 0 70px 0;

      .hero-heading {
        font-size: 60px;
      }
    }
    .pdf-desktop-columns {
      display: flex;
      justify-content: space-between;

      .pdf-desktop-column {
        width: 48%;
      }
    }
    .pdf-blurb {
      display: flex;
      max-width: 375px;

      .pdf-blurb-text {
        padding-left: 15px;
      }
    }
  }
`;

export default BuilderResourcesStyles;
